// extracted by mini-css-extract-plugin
export default {"container":"AdminUserCards_container__EWzvn","title":"AdminUserCards_title__o6GNL","user-cards":"AdminUserCards_user-cards__HWdPx"};